import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'

export const JOIN_CHANNEL = gql`
  mutation JoinChannel($appId: String!) {
    joinChannel(appId: $appId) {
      id
      userId
      messages {
        id
        message
      }
      users {
        id
      }
    }
  }
`

const useJoinChannelMutation = options => {
  const [mutate, result] = useMutation(JOIN_CHANNEL, options)

  const joinChannel = appId =>
    mutate({
      variables: {
        appId
      }
    })

  return [joinChannel, result]
}

export default useJoinChannelMutation
